import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SuperAdminLeftMenuComponent from '../components/superAdminLeftMenuComponent';
import SuperAdminHeaderComponent from '../components/superAdminHeaderComponent';
import SuperAdminFooterComponent from '../components/superAdminFooterComponent';
import { SuperAdminRouteComponent } from '../components/superAdminRouteComponent';
import { getFooterText, setTranslateLang } from '../actions/SuperAdminFooterAction'
import { logout, logOutAdmin } from '../../SuperAdminLogin/actions/superAdminLoginAction'
import ContextComponent from '../../Context/contextComponent';

class SuperAdminLayoutContainer extends Component {
    constructor(props) {
        super(props);

        this.logout = this.logout.bind(this);
    }

    componentWillMount() {
        // window.addEventListener("beforeunload", this.onUnload); 
       // window.addEventListener('mouseover', ()=>this.checkLoginTime(this));
        console.log(this.props.login)
        // if (this.props.login.authTokenId != "") {

            
        // }else{
            
        //     logout();
        //     this.props.history.push('/superadmin/login');
        // }
        this.props.actions.getFooterText();
    }

    // componentWillUnmount() {
    //     window.removeEventListener("beforeunload", this.onUnload); 
    //     //window.removeEventListener("mouseover",  ()=>this.checkLoginTime(this));
    // }

    // onUnload = e => { // the method that will be used for both add and remove event
    //     localStorage.clear(); 
    //  } 

    //  checkLoginTime = (that) => {  
    //     var userTimeLogin = new Date(sessionStorage.getItem('Time'));
    //     //add 15 minutes to date
    //     var minutesToAdd=15;
    //    var currentDate = new Date();
    //    var userTimeLoginAdd = new Date(userTimeLogin.getTime() + minutesToAdd*60000);
 
    //   if(userTimeLoginAdd.getTime() >= currentDate.getTime()){
        
    // }
    //     else{
    //         that.logout();
    //     }
    //   } 

    logout() {
        logout();
        this.props.actions.logOutAdmin();
        this.props.history.push('/superadmin/login');
    }
    setLanguage = (lang) =>{
        this.props.actions.setTranslateLang(
            lang,
            this.props.dispatch
        )
    }
    render() {
        return (
               <div> 
               
               <SuperAdminLeftMenuComponent logout={this.logout} />
                <section className="wrapper scrollable">
                <SuperAdminHeaderComponent logout={this.logout}
                    setLanguage = {this.setLanguage}  />
                <div className="main-grid fgf">
                <SuperAdminRouteComponent />
                <ContextComponent />
                </div>
                <SuperAdminFooterComponent footerText={this.props.footerText} />
                </section>
              </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getFooterText, 
            logOutAdmin,
            setTranslateLang
        }, dispatch)
    };
};

function mapStateToProps({ superAdminLayoutReducer,superAdminLoginReducer }) {
    return {
        footerText: superAdminLayoutReducer.footerText,
        login: {
            authTokenId: superAdminLoginReducer.authTokenId,
            adminId: superAdminLoginReducer.userId
        }

    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SuperAdminLayoutContainer))